module.exports = __webpack_public_path__ + "img/operation_rate.2001da64.svg";